import { render, staticRenderFns } from "./WorkspaceNewCol.vue?vue&type=template&id=c650abec&"
import script from "./WorkspaceNewCol.vue?vue&type=script&lang=js&"
export * from "./WorkspaceNewCol.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceNewCol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports